export default "__VITE_ASSET__D8QJfKZ4__"